import RateSection from './RateSection.vue'

export default RateSection
